import React from 'react';
import { Modal } from 'antd';
// import deleteIcon from '../../../assets/images/delete-icon.svg';
import AlumlyButton from '../../../components/AlumlyButton';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  icon: any;
  message: string;
  handleConfirm: () => void;
  labelConfirm?: string;
  labelCancel?: string;
  handleClose: () => void;
}
const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = (props) => {
  const {
    isOpen, handleClose, handleConfirm, message, icon, labelCancel, labelConfirm,
  } = props;
  return (
    <Modal open={isOpen} onCancel={handleClose} footer={null} centered width={600}>
      <div style={{ textAlign: 'center', marginTop: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src={icon} alt="" style={{ width: '70px', height: '70px' }} />
        </div>
        <div style={{ fontSize: 20, fontWeight: 'bold' }}>{message}</div>
      </div>
      <div style={{
        display: 'flex', justifyContent: 'center', marginTop: 24, paddingTop: 16, paddingBottom: 8, gap: 16,
      }}
      >
        <AlumlyButton label="rxvWhite" width={180} onClick={handleClose}>{labelCancel}</AlumlyButton>
        <AlumlyButton
          label="rxv"
          width={180}
          onClick={() => handleConfirm()}
        >
          {labelConfirm}
        </AlumlyButton>
      </div>
    </Modal>
  );
};

DeleteConfirmModal.defaultProps = {
  labelCancel: 'Cancel',
  labelConfirm: 'Confirm',
};
export default DeleteConfirmModal;
